(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-about [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-about')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-chero [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-chero')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-cta [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-cta')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function setup(root) {
    if (root.dataset.nphFaqReady) return;
    root.dataset.nphFaqReady = '1';
    var triggers = root.querySelectorAll('.nph-faq__q');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function () {
        var item = this.closest('.nph-faq__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-faq [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  function init(scope) {
    var sections = (scope || document).querySelectorAll('.nph-faq');
    for (var i = 0; i < sections.length; i++) { setup(sections[i]); }
    reveal(scope);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-faq')) {
      init(e.target);
    }
  });

  // Theme editor: open the question the merchant selects.
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.nph-faq__item') : null;
    if (!item || item.classList.contains('is-open')) return;
    var q = item.querySelector('.nph-faq__q');
    if (q) q.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-page-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // In the theme editor Shopify re-renders sections on the fly; load-time JS won't
  // re-run for that new markup, so show everything immediately instead of leaving it
  // hidden by the reveal animation.
  var design = !!(window.Shopify && window.Shopify.designMode);

  function activate(video) {
    if (video.dataset.heroLoaded) return;
    video.dataset.heroLoaded = '1';
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
    }
    video.load();
    if (video.getAttribute('data-hero-autoplay') === 'true' && !reduce) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function initVideos(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('.nph-hero__video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) { activate(videos[i]); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    for (var j = 0; j < videos.length; j++) { io.observe(videos[j]); }
  }

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-hero [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  function init(scope) {
    initVideos(scope);
    reveal(scope);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-run when the theme editor loads/re-renders this section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-hero')) {
      init(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function setupSection(root) {
    if (root.dataset.nphSvcReady) return;
    root.dataset.nphSvcReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.nph-svc__item'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.nph-svc__img'));
    if (!items.length) return;

    function activate(idx) {
      items.forEach(function (it, i) {
        var on = i === idx;
        it.classList.toggle('is-active', on);
        var btn = it.querySelector('.nph-svc__trigger');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      imgs.forEach(function (im, i) {
        im.classList.toggle('is-active', i === idx);
      });
    }

    items.forEach(function (it, i) {
      var btn = it.querySelector('.nph-svc__trigger');
      if (btn) btn.addEventListener('click', function () { activate(i); });
    });
  }

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-svc [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  function init(scope) {
    var sections = (scope || document).querySelectorAll('.nph-svc');
    for (var i = 0; i < sections.length; i++) { setupSection(sections[i]); }
    reveal(scope);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-svc')) {
      init(e.target);
    }
  });

  // Theme editor: open the block the merchant selects.
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.nph-svc__item') : null;
    if (!item) return;
    var trigger = item.querySelector('.nph-svc__trigger');
    if (trigger) trigger.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-tst [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-tst')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-trust [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-trust')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.nph-why [data-reveal]');
    if (!els.length) return;

    if (reduce || design || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-revealed'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.05 });

    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', function () { reveal(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.nph-why')) {
      reveal(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
